module.exports = __webpack_public_path__ + "img/jn-back.6d081540.png";